<template>
  <v-container fluid class="marketplatform-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-platform`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-facebook-messenger</v-icon>
            Platform
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-tokens`"
          >
            <v-icon class="mr-3">mdi-file-document-multiple</v-icon>
            Pages
          </v-tab>
          <v-tab-item
            :value="'tab-platform'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Platform</p>
                      <v-select
                        class="mb-4"
                        :items=marketplatformtype
                        v-on:change="onChangePlatform($event, 'platformtype')"
                        v-bind:value="initvalue.platformtype"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the platform type">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePlatform($event, 'platformname')"
                        v-bind:value="initvalue.platformname"
                        placeholder="Platform Name"
                        persistent-hint
                        single-line hint="Enter the platform name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.platformstatus"
                        outlined
                        dense
                        v-on:change="onChangePlatform($event, 'platformstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                      <v-textarea
                        v-on:change="onChangePlatform($event, 'platformnote')"
                        v-bind:value="initvalue.platformnote"                        
                        outlined
                        rows=1
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePlatform($event, 'user_id')"
                        v-bind:value="initvalue.user_id"
                        placeholder="User Id"
                        persistent-hint
                        single-line hint="Enter the user id">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePlatform($event, 'app_id')"
                        v-bind:value="initvalue.app_id"
                        placeholder="App Id"
                        persistent-hint
                        single-line hint="Enter the app id">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePlatform($event, 'app_secret')"
                        v-bind:value="initvalue.app_secret"
                        placeholder="App Secret"
                        persistent-hint
                        single-line hint="Enter the app sercret">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/marketplatform/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateMarketPlatform()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-tokens'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Pages</p>
                      </v-col>
                      <v-col md="1" align="right">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isUpdateToken = true"
                        >
                          Token
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="pagedate"
                        :headers="pageHeaders"
                        :items="platformpages"
                        :items-per-page="500"
                        class="elevation-0"
                      >                    
                        <template v-slot:item.pagename="{ item }">
                          <p class="two-line">{{ item.pagename }}</p>
                          <p class="two-line">{{ item.pagecategory }}</p>
                          <p class="two-line">{{ item.pageid }}</p>
                        </template>
                        <template v-slot:item.access_token="{ item }">
                          <p class="two-line" style="word-wrap: break-word; word-break: break-all; table-layout: fixed;">{{ item.access_token }}</p>
                        </template>
                        <template v-slot:item.pagedate="{ item }">
                          <p class="two-line">{{ new Date(item.pagedate).toLocaleString("en-SG", {year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric"})}}</p>                          
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="copyAccessToken(item)"
                          >
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/marketproject/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div>
      <v-dialog
      v-model="isUpdateToken"
      persistent
      width="800px"
      max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Update Token</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    @input="onChangeToken($event, 'usertoken')"
                    v-bind:value="initvalue.usertoken"                        
                    outlined
                    rows=5
                    label="User Token"
                    hint="please enter the user token"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUpdateToken=false; add_campaign={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateMarketPlatformToken"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      initvalue: {},
      marketplatform: {},
      change_platform: {},
      change_token: {},
      marketplatformtype: ['Facebook', 'Instagram', 'TikTok', 'Telegram', 'WhatsApp', 'YouTube'],
      pageHeaders: [
        { text: "Date", value: "pagedate", width: "10%" },
        { text: "Page", value: "pagename", width: "30%" },
        { text: "Access Token", value: "access_token", width: "50%"  },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      platformpages: [],
      error: undefined,
      errortags: false,
      errorindex: undefined,
      isUpdateToken: false,
      imageurl: undefined,
    }
  },
  computed: {
    ...mapState('MarketPlatform', ['isReceiving']),
  },
  methods: {
    ...mapActions('MarketPlatform', 
    [ 'getMarketPlatformsRequest',
      'updateMarketPlatformRequest','updateMarketPlatformTokenRequest',
    ]),
    async copyAccessToken(item){
      await navigator.clipboard.writeText(item.access_token);
    },
    async updateMarketPlatform() {
      this.change_platform._id = this.initvalue._id;
      await this.updateMarketPlatformRequest(this.change_platform);
      router.push('/marketplatform/list');
    },
    async updateMarketPlatformToken() {
      this.change_token._id = this.initvalue._id;
      let response = await this.updateMarketPlatformTokenRequest(this.change_token);
      this.platformpages = Object.assign([], response.pages);
      this.isUpdateToken = false;
      this.change_platform = Object.assign({});
    },
    onChangePlatform(value, field){
      this.change_platform[field] = value;
    },
    onChangeToken(value, field){
      this.change_token[field] = value;
    },
       
  },

  async created () {
    this.initvalue = this.$route.params;
    this.platformpages = this.initvalue.pages;
    if(!this.initvalue._id) this.$router.push({ name: 'MarketPlatformList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
